import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { setupAuthInterceptor } from "../hooks/useAuthInterceptor";

export const AuthInterceptorSetup = () => {
  const { getAccessTokenSilently } = useAuth0();

  React.useEffect(() => {
    const cleanup = setupAuthInterceptor(getAccessTokenSilently);
    return () => {
      // Guarded: an exception thrown from a passive-effect cleanup during a
      // root teardown is unrecoverable and leaves a blank document.
      if (typeof cleanup === "function") {
        cleanup();
      }
    };
  }, [getAccessTokenSilently]);

  return null;
};
